import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from '../services/axios';
import * as authActions from '../store/modules/auth/actions';
import { parseJwt } from '../utils/parseJwt';

export function useAuthFromUrlToken() {
  const dispatch = useDispatch();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const tokenFromUrl = params.get('token');

      if (tokenFromUrl) {
        try {
          localStorage.setItem('token', tokenFromUrl);
          axios.defaults.headers.Authorization = `Bearer ${tokenFromUrl}`;

          const payload = parseJwt(tokenFromUrl);
          const id = payload?.id;
          if (!id) throw new Error();

          const { data } = await axios.get(`/user/${id}`);

          // console.log('[AUTH BOOTSTRAP] iniciou');
          // console.log('[AUTH BOOTSTRAP] token URL:', tokenFromUrl);
          // console.log('[AUTH BOOTSTRAP] token LS:', localStorage.getItem('token'));

          dispatch(authActions.loginSuccess({
            token: tokenFromUrl,
            user: {
              id: data.id,
              nome: data.nome,
              cpf: data.cpf,
              email: data.email,
              nivel: data.nivel_acesso,
            },
          }));
        } catch {
          dispatch(authActions.loginFailure());
        }
      }

      dispatch(authActions.authBootstrapFinished());
    };

    run();
  }, [dispatch]);
}
